import { Select, SelectProps } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { PhoneNumber } from '../../../../whatsapp-business-account/phone-number'

type PhoneNumberSelectProps = {
    phoneNumbers: PhoneNumber[]
} & SelectProps

export function PhoneNumberSelect({ phoneNumbers, placeholder, ...props }: PhoneNumberSelectProps) {
    const { t } = useTranslation()

    return (
        <Select
            {...props}
            placeholder={placeholder ?? t('Select phone number')}
            notFoundContent={t('No phone numbers found for this account')}
            options={phoneNumbers.map((phoneNumber) => ({
                label: `${phoneNumber.name} (${phoneNumber.number})`,
                value: phoneNumber.id,
            }))}
        />
    )
}
